<template>
  <div class="container  mt-3">
    <div class="form-horizontal">
      <div class="form-group row">
        
        <label class="col-12 col-sm-3 col-md-4 col-form-label">Estado</label>
        <div class="col-12 col-sm-9 col-md-8">          
          <button v-if="estudiante.activo" class="pt-0 pb-0 mt-1 mr-1 btn btn-success" 
          @click="procesarCambiarEstado(0)" title="Click para quitar">Activo</button>
          <button v-else class="pt-0 pb-0 mt-1 mr-1 btn btn-dark" 
          @click="procesarCambiarEstado(1)" title="Click para agregar">No Activo</button>   
        </div>
      </div>
    </div>
    <b-modal @ok="procesar" @cancel="observacion=''" v-model="changeObservacion"  id="modalObservacion"
    :ok-disabled="observacion.length<observacionMin"  title="Motivo del cambio">
      <div class="mb-2">
        <b-form-textarea
          id="textarea"
          v-model="observacion"
          placeholder="Cuéntanos, ¿por qué es necesario hacer este cambio?"
          rows="3"
          max-rows="6"
          maxlength="100"
        ></b-form-textarea>
        <pre class="d-block text-right">{{ observacion.length }}/{{ observacionMin }}</pre>
      </div>
    </b-modal>
  </div>
  
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import Vue from 'vue';
  
  export default {
    name: 'DetalleActivo',
    data () {
      return {
        curso:null,
        value:null,
        changeObservacion:false,
        observacionMin:10,
        observacion:''
      }
    },
    props: {
      estudiante: Object
    },
    mounted () {
      
    },
    methods:{
      ...mapActions({
        fetchDetalle: 'estudiantes/fetchDetalle',
        setWarning: 'setWarning',
      }),
      ...mapMutations({
        
      }),
      procesar(){
        if(this.permiso('71A798F')){
          Vue.http.post('user/cambiar-activo',{id:this.estudiante.id,activo:this.value, observacion:this.observacion})
            .then((response)=>{
              this.limpiar()
              this.fetchDetalle(this.estudiante.id)
            })
            .catch(error=>{
              if (error && error.body && error.body.error) {
                this.setWarning(error.body.error)
              } else {
                this.setWarning(error)
              }
              console.log(error)
            })
        }else{
          this.setWarning('No tiene permiso para esta operación')
          return
        }
      },
      procesarCambiarEstado(value){
        this.value = value;
        this.changeObservacion = true;
        this.observacion = '';
      },
      limpiar(){
        this.changeObservacion = false; 
        this.observacion = '';
      }
    },
    computed:{
      ...mapState({
        
      }),
      ...mapGetters({
        permiso: 'auth/permiso', 
        
      }),
      procesable: {
        get () {
          return (this.curso)
        },
        set(value){}
      },
    }
  }
</script>

<style scope>
  .programar_wrapper .form-container{
      
  }
	.programar_wrapper{
    
	}
</style>

